import { Directive, ElementRef, inject } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[passwordPolicy]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PasswordPolicyDirective, multi: true }],
})
export class PasswordPolicyDirective implements Validator {
    public readonly el = inject(ElementRef);

    static validatePassword(c: UntypedFormControl): ValidationErrors | null {
        const lower = /(?=.*?[a-z])/.test(c.value);
        const upper = /(?=.*?[A-Z])/.test(c.value);
        const digit = /(?=.*?[0-9])/.test(c.value);
        const ob: any = {};
        const whiteSpace = c.value?.includes(' ');

        if (!lower || !upper) {
            ob.upperlower = true;
        }

        if (!digit) {
            ob.digit = true;
        }

        if (whiteSpace) {
            ob.whitespace = true;
        }

        if (c.value?.length < 10) {
            ob.length = true;
        }

        return ob;
    }

    validate(c: UntypedFormControl): { [key: string]: any } {
        return PasswordPolicyDirective.validatePassword(c);
    }
}
